<craft-idea-custom-item
  *ngFor="let val of idea.custom | slice: 0 : maxFieldsSize; trackBy: identify"
  [field]="fieldsMap[val.id]"
  [optionsMap]="optionsMap"
  [value]="val"
  class="item"
></craft-idea-custom-item>
